import Background from 'umg-ember-backend/components/page-builder/options/form/section/background';
import CustomOptions from 'umg-ember-backend/components/page-builder/options/form/section/custom-options';
import DisplayOptions from 'umg-ember-backend/components/page-builder/options/form/section/display-options';
import Headline from 'umg-ember-backend/components/page-builder/options/form/section/headline';
import Selectors from 'umg-ember-backend/components/page-builder/options/form/section/selectors';
import Text from 'umg-ember-backend/components/page-builder/options/form/section/text';

<template>
  <DisplayOptions
    @form={{@form}}
    @elementConfig={{@elementConfig}}
    @mlp={{@mlp}}
  />
  <Text @form={{@form}} @elementConfig={{@elementConfig}} @mlp={{@mlp}} />
  <Headline @form={{@form}} @elementConfig={{@elementConfig}} @mlp={{@mlp}} />
  <Background @form={{@form}} @elementConfig={{@elementConfig}} @mlp={{@mlp}} />
  <Selectors @form={{@form}} @elementConfig={{@elementConfig}} @mlp={{@mlp}} />
  <CustomOptions
    @form={{@form}}
    @elementConfig={{@elementConfig}}
    @mlp={{@mlp}}
  />
</template>
